var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 41,
    viewBox: "0 0 25 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1413 8.11674C14.9404 8.11674 17.2167 6.29637 17.2167 4.05837C17.2167 1.82037 14.9404 0 12.1413 0C9.343 0 7.06616 1.82037 7.06616 4.05837C7.06616 6.29637 9.343 8.11674 12.1413 8.11674Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2336 20.8348C24.2647 20.7553 24.2718 20.6694 24.251 20.5826L21.7248 9.86562C21.5219 8.86277 20.4558 8.13574 19.1901 8.13574H5.0726C3.8063 8.13574 2.74072 8.86356 2.54172 9.85223L0.0116989 20.5826C-0.00862002 20.6694 -0.00196924 20.7553 0.0288171 20.8348C0.00923698 20.9331 0 21.0272 0 21.1218C0 22.2564 1.15449 23.1796 2.57411 23.1796C3.81455 23.1796 4.87668 22.4705 5.10339 21.4821L6.69762 13.5132L6.67706 38.9429C6.67706 40.0781 7.83093 41.0003 9.25043 41.0003C10.6699 41.0003 11.8244 40.0771 11.8244 38.9429V26.3556H12.4384V38.9428C12.4384 40.078 13.5931 41.0002 15.0134 41.0002C16.4321 41.0002 17.5863 40.077 17.5863 38.9424L17.5654 13.5132L19.1623 21.4939C19.3864 22.4705 20.4494 23.1796 21.6898 23.1796C23.1087 23.1796 24.2632 22.2564 24.2632 21.1218C24.2628 21.0272 24.2536 20.932 24.2336 20.8348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMen);
export default __webpack_public_path__ + "static/media/men.1a8df0f351d635a04ba46f08503525bd.svg";
export { ForwardRef as ReactComponent };